import React, { useState, useEffect } from "react";
import LoginImage from "../Images/login_image.png";
import icon2 from "../Images/Frame.png";
import EmailInputField from "../reusableField/EmailInputField";
import TextInputField from "../reusableField/TextInputField";
import { Col } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { emailRegex, passwordRegex } from "../regex/regex";
import "./LoginPage.css";
import { BASE_URL } from "./apiConfig";
import { useQuery, useApolloClient } from "@apollo/client";
import {
  CURRENT_USER_ACCOUNT,
  CURRENT_USER_PROFIILE,
} from "../services/userApi";

const LoginPage = ({ setIsAuthenticated }) => {
  const { data: accountData, loading: accountloading } =
    useQuery(CURRENT_USER_ACCOUNT);
  const accountIdFromQuery = accountData?.currentUserAccount?.id;
  const client = useApolloClient();
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const appKey = "7cb80ffc8df6a5bf488e69f001ee0ab3";
  const validateEmail = () => {
    if (!emailRegex.test(loginId)) {
      setMessage("Email is entered wrong.");
      setMessageType("error");
      return false;
    } else {
      setMessageType("success");
      return true;
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setMessage("");
    setEmailError("");
    setPasswordError("");

    let valid = true;
    if (!loginId) {
      setEmailError("Please enter your email.");
      valid = false;
    }

    if (!password) {
      setPasswordError("Please enter your password.");
      valid = false;
    }

    if (!valid) return;

    if (!validateEmail()) return;

    setLoginLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/user_validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: loginId,
          password,
          appkey: appKey,
          session: "12434",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // const data = await response.json();
        localStorage.setItem("accessToken", data.access_token);

        // Immediately fetch account info using Apollo client so we can decide where to navigate
        try {
          const accountRes = await client.query({
            query: CURRENT_USER_ACCOUNT,
            fetchPolicy: "network-only",
          });
          const freshAccountId = accountRes?.data?.currentUserAccount?.id;

          setIsAuthenticated(true);

          // If accountId is not 1 navigate to /leads, otherwise default to /client
          if (freshAccountId && freshAccountId === 1) {
            navigate("/client");
          } else {
            navigate("/userdashboard");
          }
        } catch (err) {
          // If fetching account fails, fallback to original navigation
          setIsAuthenticated(true);
          navigate("/client");
        }
      } else {
        // const errorData = await response.json();
        setMessage(data.detail || "Email or Password is incorrect.");
        setMessageType("error");
      }

      // if (!response.ok) {
      //     throw new Error(data.detail || "Email or Password is incorrect.");
      // }

      // // Store JWT token
      // localStorage.setItem("token", data.access_token);
      // localStorage.setItem("name", data.name);
      // setIsAuthenticated(true);
      // navigate("/dashboard"); // Redirect after successful login
    } catch (error) {
      setMessage("Error: Unable to log in. Please try again.");
      setMessageType("error");
    } finally {
      setLoginLoading(false);
    }
  };

  // const generateShapes = () => {
  //     const shapes = [];
  //     const shapeTypes = ["square", "triangle", "star"];
  //     for (let i = 0; i < 50; i++) {
  //         const shapeType = shapeTypes[i % shapeTypes.length];
  //         const leftPosition = Math.random() * 100 + "%";
  //         const topPosition = Math.random() * 100 + "%";
  //         const animationDuration = Math.random() * 10 + 10 + "s";
  //         const animationDelay = Math.random() * 5 + "s";

  //         shapes.push(
  //             <div
  //                 key={i}
  //                 className={`shape ${shapeType}`}
  //                 style={{
  //                     left: leftPosition,
  //                     top: topPosition,
  //                     animationDuration: animationDuration,
  //                     animationDelay: animationDelay,
  //                 }}
  //             ></div>
  //         );
  //     }
  //     return shapes;
  // };

  return (
    <div className="background-color">
      {/* {generateShapes()} */}
      <div className="login-login-container">
        <div className="login-wrapper-container">
          <div className="login-illustration-container">
            <img
              src={LoginImage}
              alt="Illustration"
              className="login-illustration"
            />
          </div>
          <div className="login-form-container">
            <div className="login-border">
              <img src={icon2} alt="icon2" className="login-icon2" />
              <p className="login-welcome-text">Welcome</p>

              <form className="login-login-form" onSubmit={handleLogin}>
                <div className="login-form-group">
                  <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                    Login ID
                  </label>
                  <Col sm={12} xs={12} md={12} lg={12}>
                    <EmailInputField
                      name="Email"
                      placeholder="Enter Login ID "
                      type="email"
                      value={loginId}
                      onChange={(e) => {
                        setLoginId(e.target.value);
                        setEmailError("");
                      }}
                      feedbackMessage="Please enter Email."
                      validationRegex={emailRegex}
                      validationErrorMessage="Please enter a valid Email."
                    />
                    {emailError && (
                      <p className="login-emailandpassword-error-message">
                        {emailError}
                      </p>
                    )}
                  </Col>
                </div>
                <div className="login-form-group">
                  <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                    Password
                  </label>
                  <Col sm={12} xs={12} md={12} lg={12}>
                    <div className="login-password-field-container">
                      <TextInputField
                        placeholder="Enter Password"
                        name="password"
                        type={passwordVisible ? "text" : "password"}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setPasswordError("");
                        }}
                        autoComplete="new-password"
                        feedbackMessage="Please enter your password."
                        validationRegex={passwordRegex}
                      // validationErrorMessage="Password is required."
                      />
                      {passwordError && (
                        <p className="login-emailandpassword-error-message">
                          {passwordError}
                        </p>
                      )}
                      {password && (
                        <span
                          className="login-eye-icon"
                          onClick={() => setPasswordVisible(!passwordVisible)}
                        >
                          {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      )}
                    </div>
                  </Col>
                </div>
                {message && (
                  <p className={`login-backend-error-message ${messageType}`}>
                    {message}
                  </p>
                )}
                <div className="login-submit-container">
                  <button
                    type="submit"
                    className="login-submit-btn"
                    disabled={loginLoading}
                  >
                    {loginLoading ? "Loading..." : "Submit"}
                  </button>
                </div>
                <div>
                  <p className="login-forget-password">
                    Forget Password?&nbsp;
                    <span
                      onClick={() => navigate("/forgot-password")}
                      className="login-forget-password-click-here"
                    >
                      Click Here
                    </span>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
